import { render, staticRenderFns } from "./dynamic-document-screen-width-configuration-template.vue?vue&type=template&id=0cc3f139&scoped=true&"
import script from "./dynamic-document-screen-width-configuration-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-screen-width-configuration-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-screen-width-configuration-template.vue?vue&type=style&index=0&id=0cc3f139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc3f139",
  null
  
)

export default component.exports